module.exports = __webpack_public_path__ + "assets/e_mastercard-b58fe3.svg";